var map = {
	"./baby-freeze.png": 6207,
	"./cassette.png": 2567,
	"./enceinte.png": 1542,
	"./icone-yeux-fermes.png": 3474,
	"./moonwalk.png": 4607,
	"./popping.png": 9970,
	"./toprock.png": 5677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8032;